import { Abwesenheit } from '@/domain/mitarbeiter/features/rotationsplan/entities/Abwesenheit';
import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { AbwesenheitCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/components/AbwesenheitCard';
import { StationMitarbeiterCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/components/StationMitarbeiterCard';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

export function renderRotationsplaeneByMitarbeiter({
  rotationsplaene,
  currentStartOfWeek,
  currentEndOfWeek,
}: {
  rotationsplaene: Rotationsplan[];
  currentEndOfWeek: string;
  currentStartOfWeek: string;
}) {
  return rotationsplaene.map((rotationsplan) => {
    const intervals: (ArbeitsbereichStation | Abwesenheit)[] = [
      ...rotationsplan.allStationen,
      ...rotationsplan.abwesenheiten,
    ];

    return intervals
      .filter(
        (interval) =>
          dayjs(interval.von).isSameOrBefore(currentEndOfWeek) &&
          dayjs(interval.bis).isSameOrAfter(currentStartOfWeek),
      )
      .sort((a, b) => dayjs(a.von).diff(dayjs(b.von), 'day'))
      .map((interval) => {
        if (interval instanceof Abwesenheit) {
          const hasOverlaps = intervals.some(
            (other) =>
              other.id !== interval.id &&
              dayjs(interval.von).isSameOrBefore(dayjs(other.bis)) &&
              dayjs(interval.bis).isSameOrAfter(dayjs(other.von)),
          );

          return (
            !hasOverlaps && (
              <AbwesenheitCard
                key={interval.id}
                abwesenheit={interval}
                beruf={rotationsplan.beruf}
                mitarbeiter={rotationsplan.mitarbeiter}
                lehrjahr={rotationsplan.currentLehrjahr}
              />
            )
          );
        }

        const konfliktStationen =
          rotationsplan.getUeberschneidendeStationen(interval);

        return (
          <StationMitarbeiterCard
            key={interval.id}
            mitarbeiter={rotationsplan.mitarbeiter}
            station={interval}
            lehrjahr={rotationsplan.currentLehrjahr}
            beruf={rotationsplan.beruf}
            currentStartOfWeek={currentStartOfWeek}
            currentEndOfWeek={currentEndOfWeek}
            abwesenheiten={rotationsplan.abwesenheitenByStationId(interval.id)}
            konfliktStationen={konfliktStationen}
          />
        );
      });
  });
}
